import { render, staticRenderFns } from "./RevealContent.vue?vue&type=template&id=2d56275e"
import script from "./RevealContent.vue?vue&type=script&lang=js"
export * from "./RevealContent.vue?vue&type=script&lang=js"
import style0 from "./RevealContent.vue?vue&type=style&index=0&id=2d56275e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports